import { render, staticRenderFns } from "./PermissionDenied.vue?vue&type=template&id=5061e562&scoped=true"
import script from "./PermissionDenied.vue?vue&type=script&lang=js"
export * from "./PermissionDenied.vue?vue&type=script&lang=js"
import style0 from "./PermissionDenied.vue?vue&type=style&index=0&id=5061e562&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5061e562",
  null
  
)

export default component.exports